module.exports = __webpack_public_path__ + "static/img/camera.1012c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/video/camera.png
// module id = nxJ1
// module chunks = 0